import React from 'react';
import {
  Box,
  Container,
  Typography,
  Link,
  Grid,
  useTheme,
} from '@mui/material';
import {
  Email as EmailIcon,
  Phone as PhoneIcon,
  LocationOn as LocationIcon,
} from '@mui/icons-material';

export const Footer: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        py: 4,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                          <Box
              component="img"
              src="/images/SAGRF_Logo.jpg"
              alt="SAGRF Logo"
                sx={{
                  maxHeight: 50,
                  maxWidth: 75,
                  width: 'auto',
                  height: 'auto',
                  mr: 2,
                  borderRadius: 1,
                  backgroundColor: 'rgba(255,255,255,0.1)',
                  padding: 0.5,
                  objectFit: 'contain',
                }}
              />
              <Box>
                <Typography variant="h6" gutterBottom>
                  South African Gallery Rifle Federation
                </Typography>
              </Box>
            </Box>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Promoting gallery rifle shooting in South Africa through education, 
              competition, and community building.
            </Typography>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              Contact Information
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <EmailIcon sx={{ mr: 1, fontSize: 'small' }} />
              <Link href="mailto:Falcodor116@gmail.com" color="inherit" underline="hover">
                Falcodor116@gmail.com
              </Link>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <PhoneIcon sx={{ mr: 1, fontSize: 'small' }} />
              <Link href="tel:+27823193534" color="inherit" underline="hover">
                +27 82 319 3534
              </Link>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <LocationIcon sx={{ mr: 1, fontSize: 'small' }} />
              <Typography variant="body2">
                South Africa
              </Typography>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="/rules" color="inherit" underline="hover">
                Rules & Regulations
              </Link>
              <Link href="/gallery" color="inherit" underline="hover">
                Photo Gallery
              </Link>
              <Link href="/membership" color="inherit" underline="hover">
                Membership
              </Link>
            </Box>
          </Grid>
        </Grid>
        
        <Box sx={{ borderTop: 1, borderColor: 'rgba(255,255,255,0.2)', mt: 3, pt: 2 }}>
          <Typography variant="body2" align="center">
            © {new Date().getFullYear()} South African Gallery Rifle Federation. 
            All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}; 